/**
 *
 * timeZone, setTimeZone from TimeZoneContext
 *
 * default/null is equal to the default timeZone
 */

import React, { useContext, useEffect, useState } from 'react';
import Select from '../../inputs/select';
import styled from 'styled-components';
import { TimeZoneContext, TIMEZONES_LABELS } from './TimeZoneContext';
const SelectWrapper = styled.div`
  width: 300px;
`;
export const TimeZoneOverrideSelector = ({
  defaultTimeZoneLabel
}) => {
  const {
    setTimeZone,
    timeZone
  } = useContext(TimeZoneContext);
  const [override, setOverride] = useState(null);
  useEffect(() => {
    setTimeZone(override);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [override]);
  return /*#__PURE__*/React.createElement(SelectWrapper, null, /*#__PURE__*/React.createElement(Select, {
    placeholder: "Select a Time Zone",
    "data-testid": "TimeZone-selector",
    maxHeight: 250,
    onChange: value => {
      setOverride(value);
    },
    value: timeZone ?? override,
    options: [{
      value: null,
      label: defaultTimeZoneLabel
    }, ...TIMEZONES_LABELS]
  }));
};
export default TimeZoneOverrideSelector;
//# sourceMappingURL=TimeZoneOverrideSelector.js.map